// extracted by mini-css-extract-plugin
module.exports =  {"root":"H6svOqH06y7gKlXb04ND","footer":"mfrcU2SKXkpZzeKnzXb7"};